export const getDomains = () =>
  window.location.hostname.split('.').filter(domain => domain !== 'media')

export const formatURL = (subdomain, path) => {
  const isLocal = getDomains().includes('localhost')

  return `http${isLocal ? '' : 's'}://${
    subdomain !== '' ? subdomain + '.' : ''
  }${isLocal ? 'localhost:3000' : 'herrmann.media'}${path || ''}`
}
